const ACTIONS_REPORT_DEFINITION_PARAMETER = {
  INVALIDATE: 'REPORT_DEFINITION_PARAMETERS_INVALIDATE',
  RECEIVE: 'REPORT_DEFINITION_PARAMETERS_RECEIVE',
  DELETE: 'REPORT_DEFINITION_PARAMETER_DELETE',
  UPDATE: 'REPORT_DEFINITION_PARAMETER_UPDATE',
};

export default ACTIONS_REPORT_DEFINITION_PARAMETER;
